import React from 'react';

import { TTextBlock } from '@wp-block-builder/blocks/Text';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): TTextBlock => ({
  id: generateRandomBlockId(),
  type: 'Text',
  style: {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 'normal',
    textAlign: 'left',
    ...style,
  },
  props: { text: 'Hello **{{firstName | default: "friend" }}**!' },
  sectionProps: {},
});

export default defineBlockButton<TTextBlock>({
  label: 'Text',
  icon: <BlockTypeIcon type="Text" />,
  defaultBlock: () => getDefaultProps({ padding: '16px 24px 16px 24px' }),
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
